import { useEffect } from 'react';

const DEFAULT_TITLE = 'EMMA';

export const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    document.title = title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};
